<form [formGroup]="groupForm" class="category-content">
    <div *ngFor="let criteria of group.commitmentCriterias;" class="commitment-container">
        <span class="commitment-title">
          <mat-icon *ngIf="criteria.template.categoryLevel > 1" class="sublevel-icon">
            subdirectory_arrow_right
          </mat-icon>
          {{ criteria.template.title }}
        </span>
      <div class="commitment-container">
        <div
          class="tv-rect-input-small-no-label width-180px"
          [ngClass]="{
            'disabled-form-field': !criteria.template.editable || isPastYearContract
          }">
          <mat-form-field>
            <input
              matInput
              realThousandsSeparator
              [value]="criteria.value"
              [readonly]="!criteria.template.editable || isPastYearContract"
            />
            <span
              *ngIf="group.category === 'baseCategory'"
              matSuffix
              class="commitment-title"
            ></span>
          </mat-form-field>
        </div>
      </div>
    </div>
</form>
